<template>
    <div id="partslist-view-page">
        <actions-menu>
            <actions-menu-item
                :v4="true"
                class="backToProduct"
                :action="() => $router.push('/productpage/' + productIdParam)"
                icon="arrow-left"
                :label="trans('pages.partslist_view.back_to_product')"
            />
            <actions-menu-item
                :v4="true"
                :action="
                    () =>
                        $router.push(
                            '/partslistedit/' +
                                productIdParam +
                                '/' +
                                partslistIdParam
                        )
                "
                icon="pencil"
                :label="trans('pages.partslist_view.edit')"
            />
            <actions-menu-item
                :v4="true"
                :action="recalculatePartslist"
                icon="refresh"
                :label="trans('pages.partslist_view.recalculate')"
            />
            <actions-menu-item
                :v4="true"
                :action="removePartslist"
                class="alert"
                icon="exclamation-circle"
                :label="trans('pages.partslist_view.delete')"
            />
        </actions-menu>

        <loader v-if="loading"></loader>
        <template v-else>
            <div class="container row">
                <div class="col-67">
                    <div class="paintlist-title">
                        <h1>{{ trans('pages.partslist_view.title') }}</h1>
                    </div>
                </div>

                <div class="col-33 barcode-container-right">
                    <img id="partslist-barcode" />
                    <barcode
                        v-if="partslistIdParam"
                        :value="partslistIdParam"
                        format="CODE128"
                        font-size="18"
                        text-margin="0"
                    >
                        {{ trans('pages.partslist_view.barcode') }}
                        {{ partslistIdParam }}
                    </barcode>
                </div>
            </div>
            <div class="container row">
                <div class="col-90">
                    <div class="paintlist-field">
                        <label for="partslistdescription">
                            {{ trans('pages.partslist_view.description') }}
                        </label>
                        <textarea
                            name="paintlistdescription"
                            v-if="partslist"
                            v-model="partslist.partslistDescription"
                            id="partslistdescription"
                            readonly
                        />
                    </div>
                </div>
            </div>
            <div class="box">
                <div class="box-title">
                    {{ trans('pages.partslist_view.info') }}
                </div>

                <div class="box-row">
                    <div class="box-25">
                        {{ trans('pages.partslist_view.partslist_number') }}
                    </div>
                    <div class="box-25">
                        <span
                            id="partslistviewid"
                            v-if="partslist"
                        >
                            {{ partslist.partslistId }}
                        </span>
                    </div>
                    <div class="box-25">
                        {{ trans('pages.partslist_view.creation_date') }}
                    </div>
                    <div class="box-25">
                        <span
                            id="partslistcreationdate"
                            v-if="partslist"
                        >
                            {{ partslist.creationdate }}
                        </span>
                    </div>
                </div>

                <div class="box-row"></div>
            </div>

            <div class="row">
                <div class="col-50">
                    <div
                        id="box-color"
                        class="box"
                    >
                        <div class="box-title">
                            {{ trans('pages.partslist_view.color') }}
                        </div>

                        <div class="box-row">
                            <div class="box-50">
                                {{ trans('pages.partslist_view.ral_color') }}
                            </div>
                            <div class="box-50">
                                <div
                                    class="paintlistelementvalue"
                                    id="partslistviewral"
                                    v-if="partslist"
                                >
                                    {{
                                        partslist.ralnr +
                                        ' ' +
                                        partslist.raltype
                                    }}
                                </div>
                            </div>
                        </div>

                        <div class="box-row">
                            <div class="box-50">
                                {{
                                    trans('pages.partslist_view.powder_number')
                                }}
                            </div>
                            <div class="box-50">
                                <div
                                    v-if="partslist"
                                    class="paintlistelementvalue"
                                    id="partslistviewpoeder"
                                >
                                    {{ partslist.code }}
                                </div>
                            </div>
                        </div>

                        <div class="box-row">
                            <div class="box-50">
                                {{ trans('pages.partslist_view.brand') }}
                            </div>
                            <div class="box-50">
                                <div
                                    class="paintlistelementvalue"
                                    v-if="partslist"
                                    id="partslistviewmerk"
                                >
                                    {{ partslist.producent }}
                                </div>
                            </div>
                        </div>

                        <div class="box-row">
                            <div class="box-50">
                                {{ trans('pages.partslist_view.info') }}
                            </div>
                            <div class="box-50">
                                <div
                                    class="paintlistelementvalue"
                                    id="partslistviewnotes"
                                    v-if="partslist"
                                >
                                    {{ partslist.colorNotes }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="col-50">
                    <div
                        id="box-contents"
                        class="box"
                    >
                        <div class="box-title">
                            {{ trans('pages.partslist_view.package_contents') }}
                        </div>

                        <div class="box-row">
                            <div class="box-50">
                                {{ trans('pages.partslist_view.total_count') }}
                            </div>
                            <div class="box-50">
                                <div
                                    v-if="partslist"
                                    class="paintlistelementvalue paintlistbold"
                                    id="partslistviewcount"
                                >
                                    {{ partslist.totalCount }}
                                </div>
                            </div>
                        </div>
                        <div class="box-row">
                            <div class="box-50">
                                {{ trans('pages.partslist_view.total_area') }}
                            </div>
                            <div class="box-50">
                                <div
                                    v-if="partslist"
                                    class="paintlistelementvalue paintlistbold"
                                    id="partslistviewarea"
                                >
                                    {{ partslist.totalArea.toFixed(2) }} m&sup2;
                                </div>
                            </div>
                        </div>
                        <div class="box-row">
                            <div class="box-50">
                                {{
                                    trans('pages.partslist_view.square_meters')
                                }}
                            </div>
                            <div class="box-50">
                                <div
                                    v-if="partslist"
                                    class="paintlistelementvalue paintlistbold"
                                    id="partslistsquaremeters"
                                >
                                    {{ partslist.squaremeters.toFixed(2) }}
                                    m&sup2;
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <h4>{{ trans('pages.partslist_view.profiles_in_package') }}</h4>
            <table
                cellspacing="0"
                cellpadding="0"
                id="profile-overview"
                class="product-table"
            >
                <thead>
                    <tr class="product-table-header-tr">
                        <th class="product-table-header-td"></th>
                        <th class="product-table-header-td"></th>
                        <th class="product-table-header-td">
                            {{ trans('pages.partslist_view.select') }}
                        </th>
                        <th class="product-table-header-td">
                            {{ trans('pages.partslist_view.image') }}
                        </th>
                        <th
                            class="product-table-header-td"
                            align="left"
                        >
                            {{ trans('pages.partslist_view.description') }}
                        </th>
                        <th
                            class="product-table-header-td"
                            align="center"
                        >
                            {{ trans('pages.partslist_view.length') }}
                        </th>
                        <th
                            class="product-table-header-td"
                            align="center"
                        >
                            {{ trans('pages.partslist_view.count') }}
                        </th>
                    </tr>
                </thead>
                <tbody v-if="records && partslist">
                    <template v-if="records.length == 0">
                        <tr>
                            <td colspan="8">
                                <li>
                                    {{
                                        trans(
                                            'pages.partslist_view.no_profiles'
                                        )
                                    }}
                                </li>
                            </td>
                        </tr>
                    </template>
                    <template v-else>
                        <tr
                            v-for="(record, recordIndex) in records"
                            :key="'record.' + recordIndex"
                            :id="'profile-row-' + record.ID"
                            class="product-table-item-tr"
                        >
                            <td class="bol-column">
                                <div
                                    :id="'left-checkbox-' + record.ID"
                                    class="bol"
                                />
                            </td>
                            <td
                                @click="
                                    $router.push(
                                        '/partslistline/' +
                                            productIdParam +
                                            '/' +
                                            partslist.partslistId +
                                            '/' +
                                            record.ID
                                    )
                                "
                                align="center"
                            >
                                <i class="material-icons">search</i>
                            </td>
                            <td align="center">
                                <ui5-checkbox
                                    class="paintlistrecord-select"
                                    :name="'select-' + record.ID"
                                    :id="'select-' + record.ID"
                                    :data-id="record.ID"
                                />
                            </td>
                            <td
                                align="center"
                                class="image-column"
                            >
                                <img
                                    :src="
                                        Config.url +
                                        '/profile/fetchImage/?profileId=' +
                                        record.profile
                                    "
                                    @click="selectedImageRecord = record"
                                    :alt="record.code"
                                />
                            </td>
                            <td align="left">
                                <div>
                                    <div class="paintlistbold">
                                        {{ record.description }}
                                    </div>
                                    <div class="paintlistdefault">
                                        {{ record.code }}
                                    </div>
                                    <div class="paintlistitalic">
                                        {{
                                            trans(
                                                'pages.partslist_view.profile_contour'
                                            )
                                        }}
                                        {{ record.contour }}
                                    </div>
                                    <div
                                        class="paintlistred"
                                        v-if="record.showPaintlist == 0"
                                    >
                                        {{
                                            trans(
                                                'pages.partslist_view.do_not_paint'
                                            )
                                        }}
                                    </div>
                                </div>
                            </td>
                            <td align="center">
                                <template v-if="record.isPart == 1">
                                    {{ trans('pages.partslist_view.piece') }}
                                </template>
                                <template v-else>
                                    {{ record.length }} mm
                                </template>
                            </td>
                            <td align="center">{{ record.count }}</td>
                        </tr>
                    </template>
                </tbody>
            </table>
        </template>
        <image-modal
            v-if="selectedImageRecord"
            :source="
                Config.url +
                '/profile/fetchImage/?profileId=' +
                selectedImageRecord.profile
            "
            @modal-click="selectedImageRecord = null"
            :title="selectedImageRecord.code"
        />
    </div>
</template>
<script>
import ActionsMenu from '../components/ActionsMenu';
import ActionsMenuItem from '../components/ActionsMenuItem';
import partslistApi from '../api/partslist';
import IsDebugMixin from '../mixins/is-debug';
import IdParamMixin from '../mixins/id-param';
import ErrorHelper from '../helpers/ErrorHelper';
import Loader from '../components/loader/Loader';
import VueBarcode from 'vue-barcode';
import NavigationFunctionsMixin from '../mixins/navigation-functions';
import {
    showConfirmDialog,
    showInfoMessage,
    showErrorMessage,
} from '../dialogs';
import ImageModal from '../components/modals/ImageModal';
import localization from '../mixins/localization';

export default {
    mixins: [
        IsDebugMixin,
        IdParamMixin('productIdParam', 'partslistIdParam'),
        NavigationFunctionsMixin,
        localization,
    ],
    components: {
        Loader,
        ActionsMenu,
        ActionsMenuItem,
        barcode: VueBarcode,
        ImageModal,
    },
    data() {
        return {
            loading: false,
            partslist: null,
            records: null,
            selectedImageRecord: null,
        };
    },
    computed: {
        Config: () => Config,
        productIdParam() {
            return this.$route.params.productId;
        },
        partslistIdParam() {
            return this.$route.params.partslistId;
        },
    },
    methods: {
        recalculatePartslist() {
            const productId = this.productIdParam;

            showConfirmDialog({
                title: this.trans(
                    'pages.partslist_view.recalculate_confirm_title'
                ),
                content: this.trans(
                    'pages.partslist_view.recalculate_confirm_content'
                ),
                confirm: () => {
                    partslistApi
                        .recalculate(productId)
                        .then((response) => {
                            showInfoMessage(
                                this.trans(
                                    'pages.partslist_view.recalculate_success'
                                )
                            );
                            this.$router.push(
                                '/partslistview/' +
                                    productId +
                                    '/' +
                                    response.data.data.newPartslistId
                            );
                        })
                        .catch(() => {
                            showErrorMessage(
                                this.trans(
                                    'pages.partslist_view.recalculate_error'
                                )
                            );
                        });
                },
                closeOnCancel: true,
                closeOnOk: true,
                confirmButton: this.trans('pages.partslist_view.yes'),
                cancelButton: this.trans('pages.partslist_view.no'),
            });
        },
        load() {
            this.$store.commit(
                'general/setPageTitle',
                this.trans('pages.partslist_view.page_title', {
                    partslistId: this.partslistIdParam,
                    productId: this.productIdParam,
                }),
                { root: true }
            );

            this.loading = true;
            partslistApi
                .fetch(this.partslistIdParam, this.productIdParam)
                .then((response) => {
                    const partslistData = response.data.data;
                    this.partslist = partslistData.partslist;
                    this.records = partslistData.records || [];
                })
                .catch((error) => {
                    const translations = {
                        'partslist.notfound': this.trans(
                            'pages.partslist_view.partslist_not_found'
                        ),
                    };
                    ErrorHelper.displayError(error, translations);
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        removePartslist() {
            showConfirmDialog({
                title: this.trans('pages.partslist_view.delete_confirm_title'),
                content: this.trans(
                    'pages.partslist_view.delete_confirm_content'
                ),
                confirm: () => {
                    partslistApi
                        .remove(this.partslistIdParam)
                        .then(() => {
                            this.goToProductPage(this.productIdParam);
                        })
                        .catch(() => {
                            showErrorMessage(
                                this.trans('pages.partslist_view.delete_error')
                            );
                        });
                },
                closeOnCancel: true,
                closeOnOk: true,
                confirmButton: this.trans('pages.partslist_view.yes'),
                cancelButton: this.trans('pages.partslist_view.no'),
            });
        },
    },
};
</script>
